// extracted by mini-css-extract-plugin
export var infoRow = "_si-2";
export var labelContainer = "_si-0";
export var rightInfo = "_si-1";